/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/* Keep per-item prices in sync with the customer-specific wholesale price. */
(function () {
  'use strict';

  var unitSelector = '.unit-price-measurement[data-jojo-base-price]';
  var scheduled = false;

  function amountInCents(element) {
    var matches = (element.textContent || '').replace(/,/g, '').match(/\d+(?:\.\d{1,2})?/g);
    return matches ? Math.round(Number(matches[matches.length - 1]) * 100) : null;
  }

  function displayedPrice(priceList, variantId) {
    var customized = priceList.querySelectorAll('.samitaWS-customized-price');
    if (customized.length) {
      for (var i = 0; i < customized.length; i++) {
        var element = customized[i];
        var variant = element.closest('[samitaws-variant-id]');
        if (element.getClientRects().length && (!variant || !variantId || variant.getAttribute('samitaws-variant-id') === variantId)) {
          return amountInCents(element);
        }
      }
      return null; // Wait for the app to render the newly selected variant.
    }

    var regular = priceList.querySelector('.price--highlight:not(.price--compare)') || priceList.querySelector('.price:not(.price--compare)');
    return regular ? amountInCents(regular) : null;
  }

  function updateUnitPrice(unit) {
    var root = unit.closest('.product-form, .product-item');
    var priceList = root && root.querySelector('.price-list');
    var output = unit.querySelector('.unit-price-measurement__price');
    if (!priceList || !output) return;

    var price = displayedPrice(priceList, unit.dataset.jojoVariantId);
    var basePrice = Number(unit.dataset.jojoBasePrice);
    var baseUnitPrice = Number(unit.dataset.jojoBaseUnitPrice);
    var quantity = Number(unit.dataset.jojoQuantityValue);
    var reference = Number(unit.dataset.jojoReferenceValue) || 1;
    if (price === null || !Number.isFinite(price) || !Number.isFinite(basePrice) || basePrice <= 0) return;

    var perUnit = unit.dataset.jojoMeasuredType === 'count' && quantity > 0
      ? Math.round(price * reference / quantity)
      : Math.round(baseUnitPrice * price / basePrice);
    if (!Number.isFinite(perUnit)) return;

    var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active || 'USD';
    var formatted = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency }).format(perUnit / 100);
    if (output.textContent.trim() !== formatted) output.textContent = formatted;
  }

  function updateAll() {
    scheduled = false;
    document.querySelectorAll(unitSelector).forEach(updateUnitPrice);
  }

  function scheduleUpdate() {
    if (!scheduled) {
      scheduled = true;
      requestAnimationFrame(updateAll);
    }
  }

  function start() {
    document.addEventListener('variant:changed', function (event) {
      var variant = event.detail && event.detail.variant;
      var root = event.target.closest('.product-form') || event.target.querySelector('.product-form');
      var unit = root && root.querySelector(unitSelector);
      if (!variant || !unit || !variant.unit_price_measurement) return;
      var measurement = variant.unit_price_measurement;
      unit.dataset.jojoVariantId = String(variant.id);
      unit.dataset.jojoBasePrice = String(variant.price);
      unit.dataset.jojoBaseUnitPrice = String(variant.unit_price);
      unit.dataset.jojoQuantityValue = String(measurement.quantity_value);
      unit.dataset.jojoReferenceValue = String(measurement.reference_value);
      unit.dataset.jojoMeasuredType = measurement.measured_type;
      scheduleUpdate();
    });

    new MutationObserver(function (changes) {
      if (changes.some(function (change) {
        var target = change.target.nodeType === 1 ? change.target : change.target.parentElement;
        if (target && target.closest('.price-list')) return true;
        return Array.prototype.some.call(change.addedNodes, function (node) {
          return node.nodeType === 1 && (node.matches('.price-list, ' + unitSelector) || node.querySelector('.price-list, ' + unitSelector));
        });
      })) scheduleUpdate();
    }).observe(document.body, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['style'] });

    scheduleUpdate();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
